import PageWrapper from "../components/common/RoutesWithAnimation";
import About from "./About";
import Contact from "./Contact";
import Experience from "./Experience";
import Landing from "./Landing";
import Recommendations from "./Recommendations";
import TopProjects from "./TopProjects";
export const MainPage = () => {
  return (
    <PageWrapper>
      <div>
        <div id="landing">
          <Landing />
        </div>
        <div id="stack">
          <About />
        </div>
        <div id="projects">
          <TopProjects />
        </div>
        <div id="experience">
          <Experience />
        </div>
        <div id="recommendations">
          <Recommendations />
        </div>
        <div id="contact">
          <Contact />
        </div>
      </div>
    </PageWrapper>
  );
};
